// extracted by mini-css-extract-plugin
export var badge = "Badge-module--badge--957df";
export var badgeHighlight = "Badge-module--badge--highlight--4c563";